import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { CookieBanner } from './CookieBanner';
import { motion } from 'motion/react';

export const PublicLayout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white selection:bg-neutral-900 selection:text-white">
      <Navbar />
      <motion.main 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="flex-grow pt-20"
      >
        <Outlet />
      </motion.main>
      <Footer />
      <CookieBanner />
    </div>
  );
};
